import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Actions} from '../../common/actions';
import TransferForm from './form';

class WarehouseTransfer extends Component {
  constructor(props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
  }

  onSubmit(formValues) {
    const {code} = formValues;
    this.props.submitManualTransfer(code);
  }

  render() {
    return (
      <TransferForm onSubmit={this.onSubmit}/>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loadingFile': state.excelReader.loading,
  };
};

const {
  submitManualTransfer,
} = Actions;

export default connect(mapStateToProps, {
  submitManualTransfer,
})(WarehouseTransfer);
